import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import { InvoiceCorrectionForm } from "@/components/forms/invoice-correction";

const InvoiceCorrectionCreatePage = () => {
  const { invoiceId } = useParams();

  return (
    <Box>
      <InvoiceCorrectionForm invoiceId={invoiceId} />
    </Box>
  );
};

export default InvoiceCorrectionCreatePage;
